// src/TermsConditions.js

import React, { useEffect } from "react";
// import { Link } from "react-router-dom";
// import { IMAGES } from "../assets/img/ImageIndex";

function TermsConditions() {
  useEffect(() => {
    // Set document title and meta tags
    document.title = 'Terms & Conditions for Business Financing USA | EnvoCapital';

    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Review EnvoCapital\'s terms and conditions for small business loans and business financing in the USA, including eligibility, repayment expectations, and important service details.');
    }
  }, []);

  return (
    <div className="loan-program-page">
        {/* <div className="page-banner-area bg-gray2">
            <div className="container mw-1380">
                <div className="row align-items-center">
                    <div className="col-lg-6">
                        <div className="page-banner-content">
                            <ul className="ps-0 list-unstyled breadcrumbs">
                                <li><Link to="/">Home</Link></li>
                                <li>Terms & Conditions</li>
                            </ul>
                            <h1>Mortgage Miracles: Transforming Dreams into Dwellings in the Real Estate Universe</h1>
                            <p>We truly care about what is best for you! From pre-approval to closing, our goal is to provide you with the best service while saving you money. We provide a completely customized experience, and will find the right loan program and best terms for you.</p>
                            <Link to="/calculate-mortgage/" className="read-more text-primary">
                                Calculate Your Payments
                                <i className="fi fi-rs-arrow-right"></i>
                            </Link>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="page-banner-img text-center text-lg-end position-relative z-1">
                            <img src={IMAGES.bannerImg5} className="img" alt="banner-img"/>
                            <img src={IMAGES.shape7} className="shape shape-7" alt="Shape1"/>
                            <img src={IMAGES.shape8} className="shape shape-8" alt="Shape2"/>
                        </div>
                    </div>
                </div>
            </div>
        </div> */}
      
        <div className="page-main-content ptb-130">
            <div className="page-area ">
                <div className="container">
                    <div id="post-423" className="post-423 page type-page status-publish hentry">
                        <div className="entry-content">
                            <p>Last updated: November 2025</p>
                            <h3 className="wp-block-heading">Terms &amp; Conditions</h3>
                            <p>
                                Welcome to EnvoCapital. By accessing, using, or engaging with our services, you agree to the following Terms &amp; Conditions. 
                                Please read them carefully. If you have any questions, you may contact us at info@envocapital.com.
                            </p>
                            <h3 className="wp-block-heading">1. Acceptance of Terms</h3>
                            <p>
                                By using our website, submitting an application, or engaging with any service provided by EnvoCapital, you acknowledge that 
                                you have read, understood, and agreed to these Terms &amp; Conditions. If you do not agree, you must discontinue use immediately.
                            </p>

                            <h3 className="wp-block-heading">2. Services Provided</h3>
                            <p>
                                EnvoCapital offers business financing solutions, advisory support, and related resources. All loan approvals, rates, and terms 
                                are subject to qualification, verification, and lender requirements. EnvoCapital reserves the right to modify or discontinue 
                                services at any time without notice.
                            </p>

                            <h3 className="wp-block-heading">3. Intellectual Property &amp; Acceptable Use</h3>
                            <p>
                                All content, branding, graphics, text, website design, and materials displayed on EnvoCapital’s digital platforms are the 
                                exclusive property of EnvoCapital unless otherwise stated.
                            </p>
                            <p>You agree not to:</p>
                            <ol className="wp-block-list">
                                <li>Copy, reproduce, distribute, or modify any content without written permission.</li>
                                <li>Use the website for unlawful, fraudulent, or unauthorized activities.</li>
                                <li>Attempt to access any secure areas without proper authorization.</li>
                            </ol>
                            <p>
                                Any misuse of our content or systems may result in restricted access, termination of service, or legal action.  
                                For intellectual property-related inquiries, contact info@envocapital.com.
                            </p>

                            <h3 className="wp-block-heading">4. Limitation of Liability</h3>
                            <p>EnvoCapital is not responsible for:</p>
                            <ol className="wp-block-list">
                                <li>Any financial decisions made based on information from our website or team.</li>
                                <li>Interruptions, delays, or errors in website functionality.</li>
                                <li>Damages resulting from third-party services, external links, or lender decisions.</li>
                            </ol>
                            <p>
                                While we aim to provide accurate and reliable information, all services and content are offered “as-is” without warranties of 
                                any kind. You agree that EnvoCapital, its partners, and its representatives shall not be held liable for any direct, indirect, 
                                or consequential damages arising from use of our services.
                            </p>

                            <h3 className="wp-block-heading">5. Registration &amp; User Responsibilities</h3>
                            <p>
                                Some services may require account creation or application submission. You agree that all information you provide is accurate, 
                                complete, and up to date. You will not impersonate another person or entity, and you will notify us if any information 
                                becomes outdated. Providing false or misleading information may result in application denial or account termination.
                            </p>

                            <h3 className="wp-block-heading">6. Password &amp; Security</h3>
                            <p>
                                If you create an account or receive secure access credentials, you are responsible for keeping login information confidential. 
                                You must notify EnvoCapital immediately if you suspect unauthorized access. EnvoCapital is not liable for losses caused by 
                                unauthorized account use.
                            </p>
                            <p>
                                We take strong security measures, but no online platform is perfectly secure. Use your credentials responsibly.
                            </p>

                            <h3 className="wp-block-heading">7. Privacy &amp; Data Usage</h3>
                            <p>
                                All personal information submitted to EnvoCapital is handled in accordance with our Privacy Policy. By using our services, 
                                you consent to the collection and processing of your data for verification, communication, underwriting, and compliance 
                                purposes.
                            </p>
                            <p>To request data-related support, email info@envocapital.com.</p>

                            <h3 className="wp-block-heading">8. Modifications to Terms</h3>
                            <p>
                                EnvoCapital may update or revise these Terms &amp; Conditions at any time. Updated versions will be posted on this page with 
                                a revised “Last Updated” date. Continued use of our services indicates acceptance of the updated terms.
                            </p>

                            <h3 className="wp-block-heading">9. Contact Information</h3>
                            <p>
                                For any questions, concerns, or support related to these Terms &amp; Conditions, you may reach us at:
                                <br /><br />
                                <strong>EnvoCapital Support Team</strong><br />
                                Email: info@envocapital.com
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  );
}

export default TermsConditions;
